import { defineMessages } from 'react-intl';


export default defineMessages({
  helloUser: {
    id: 'app.components.Header.helloUser',
    defaultMessage: 'Hello, ',
  },
  // path names
  pathHome: {
    id: 'app.components.Header.pathHome',
    defaultMessage: 'EY',
  },
  pathReward: {
    id: 'app.components.Header.pathReward',
    defaultMessage: 'Reward',
  },
  pathRewardRedeemAddress: {
    id: 'app.components.Header.pathRewardRedeemAddress',
    defaultMessage: 'Shipping Address',
  },
  pathRewardRedeemDetails: {
    id: 'app.components.Header.pathRewardRedeemDetails',
    defaultMessage: 'Redeem Details',
  },
  pathRewardRedeemConfirmed: {
    id: 'app.components.Header.pathRewardRedeemConfirmed',
    defaultMessage: 'Confirmed!',
  },
  pathRewardRedemption: {
    id: 'app.components.Header.pathRewardRedemption',
    defaultMessage: 'Details',
  },
  pathProfile: {
    id: 'app.components.Header.pathProfile',
    defaultMessage: 'Profile',
  },
  pathFavorites: {
    id: 'app.components.Header.pathFavorites',
    defaultMessage: 'Favorites',
  },
  pathLotteries: {
    id: 'app.components.Header.pathLotteries',
    defaultMessage: 'Lotteries',
  },
  pathRedemption: {
    id: 'app.components.Header.pathRedemption',
    defaultMessage: 'Redemption',
  },
  pathRedemptions: {
    id: 'app.components.Header.pathRedemptions',
    defaultMessage: 'Redemptions',
  },
  pathPoints: {
    id: 'app.components.Header.pathPoints',
    defaultMessage: 'Point History',
  },
  pathPrivacy: {
    id: 'app.components.Header.pathPrivacy',
    defaultMessage: 'Privacy Policy',
  },
  pathTerms: {
    id: 'app.components.Header.pathTerms',
    defaultMessage: 'Terms of Use',
  },
  pathFaq: {
    id: 'app.components.Header.pathFaq',
    defaultMessage: 'Faq',
  },
  pathCaregiver: {
    id: 'app.components.Header.pathCaregiver',
    defaultMessage: 'Register Caregiver',
  },
  pathLogin: {
    id: 'app.components.Header.pathLogin',
    defaultMessage: 'Login',
  },
  // actions
  actionLogin: {
    id: 'app.components.Header.actionLogin',
    defaultMessage: 'Login',
  },
  // user menu items
  menuItemRedemptions: {
    id: 'app.components.Header.menuItemRedemptions',
    defaultMessage: 'Redemption History',
  },
  menuItemPoints: {
    id: 'app.components.Header.menuItemPoints',
    defaultMessage: 'Point History',
  },
  menuItemFavorites: {
    id: 'app.components.Header.menuItemFavorites',
    defaultMessage: 'Favorites',
  },
  menuItemLotteries: {
    id: 'app.components.Header.menuItemLotteries',
    defaultMessage: 'Lotteries',
  },
  menuItemRegisterGirls: {
    id: 'app.components.Header.menuItemRegisterGirls',
    defaultMessage: 'Invite your girls',
  },
});
